import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
// import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useState } from "react";
import useAuth from "../../contexts/UserContext.tsx";
import AddSmartClassModal from "../formmodals/addsmartclassmodal/AddSmartClassModal";
import DeactivateModal from "../formmodals/deactivatemodal/DeactivateModal";
import { toast } from "sonner";

const SmartClassesTable = ({ data, schoolData, reportMode, setReload }) => {
  const [open, setOpen] = useState(false);
  const [centerId, setCenterId] = useState(null);

  const { user } = useAuth();
  const isIndividualSchool = user.view_access_list.isIndividualSchool;

  return (
    <TableContainer
      component={Paper}
      className="tableContainer"
      sx={{ boxShadow: "2px 4px 10px 1px rgba(201, 201, 201, 0.47)" }}
    >
      <div className="flex justify-between items-center">
        <span className="font-bold mb-4 ml-2">
          Smart Class Operation Status
        </span>
        {!isIndividualSchool && !reportMode && (
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddOutlinedIcon />}
            onClick={() => {
              if (!schoolData) {
                toast.error("Cannot add center. School data not found.");
              }
              setOpen(true);
            }}
          >
            Add New Center
          </Button>
        )}
      </div>
      <Table aria-label="smart classes">
        <TableHead>
          <TableRow>
            <TableCell>Center Id</TableCell>
            <TableCell>School Name</TableCell>
            <TableCell>License Start Date</TableCell>
            <TableCell>License End Date</TableCell>
            <TableCell>Payment Status</TableCell>
            <TableCell>Activation Status</TableCell>
            {user.user_type === "admin" && !reportMode && (
              <TableCell>Actions</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((row) => (
              <TableRow key={row.center_id}>
                <TableCell>{row.center_id}</TableCell>
                <TableCell>{row.center_name}</TableCell>
                <TableCell>{row.license_start_date}</TableCell>
                <TableCell>{row.license_end_date}</TableCell>
                <TableCell>
                  {row.payment_status === "N" ? (
                    <Chip
                      variant="outlined"
                      color="error"
                      icon={<CancelOutlinedIcon />}
                      label="Not Paid"
                    />
                  ) : (
                    <Chip
                      variant="outlined"
                      color="success"
                      icon={<DoneOutlinedIcon />}
                      label="Paid"
                    />
                  )}
                </TableCell>
                <TableCell>
                  {row.activation_status === "N" ? (
                    <Chip
                      variant="outlined"
                      color="error"
                      icon={<CancelOutlinedIcon />}
                      label="Inactive"
                    />
                  ) : (
                    <Chip
                      variant="outlined"
                      color="success"
                      icon={<DoneOutlinedIcon />}
                      label="Active"
                    />
                  )}
                </TableCell>
                {/* <TableCell></TableCell> */}
                {/* <TableCell><Chip variant="outlined" color="success" icon={<DoneOutlinedIcon/>} label="Active"/></TableCell> */}
                {user.user_type === "admin" && !reportMode && (
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<CancelOutlinedIcon />}
                      onClick={() => {
                        setCenterId(row.center_id);
                      }}
                    >
                      Deactivate
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <AddSmartClassModal
        open={open}
        onClose={() => setOpen(false)}
        classDetails={schoolData}
        setReload={setReload}
      />
      <DeactivateModal
        open={Boolean(centerId)}
        onClose={() => setCenterId(null)}
        centerId={centerId}
      />
    </TableContainer>
  );
};

export default SmartClassesTable;
